import React from 'react'
import Homepage from '../containers/homePage'

function Home (){
    return(
        <div className="home">
            <Homepage />
        </div>
    )
}
export default Home